// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"infoIconTooltip_tooltip__3yucC","tooltipText":"infoIconTooltip_tooltipText__2nvSj"};